<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">Huvudkontakt (steg 2 av 3)</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <p>Du som gör registreringen kommer att bli huvudkontakt för din organisation. Ange dina kontaktuppgifter och gå
          vidare till nästa steg. </p>
        <form class="reg-form" @submit.prevent="onSubmit">
          <div class="form-group reg-form__wrapper my-5 form-background-color">
            <h3 class="h4 mt-0">Ange kontaktuppgifter</h3>
            <div class="form-group">
              <label class="form-check-label--normal" for="name">Namn</label>
              <input id="name" :value="`${state.user.firstName} ${state.user.lastName}`" class="form-control"
                     disabled name="name" type="text">
            </div>
            <div class="form-group">
              <label class="form-check-label--normal" for="email">E-post</label>
              <input id="email" :value="state.user.email" class="form-control"
                     disabled name="email" type="text">
            </div>

            <div class="form-group">
              <label class="form-check-label--normal" for="orgPhone">Telefonnummer</label>
              <input id="orgPhone" v-model="form.phone" class="form-control" min="0" name="orgPhone"
                     onkeydown="return event.keyCode !== 69" placeholder="Telefonnummer" step="1">
              <div v-if="state.phoneError" id="validation-error-phone" class="d-flex rounded mt-2 p-2 invalid-input">
                <div class="mr-2">
                  <svg aria-hidden="true" aria-label="triangle-exclamation" class="svg-icon triangle-exclamation"
                       data-v-d85c0ce2=""
                       height="512" style="transform: rotate(0deg);" viewBox="0 0 512 512"
                       width="512" xmlns="http://www.w3.org/2000/svg">
                    <g class="svg__color" fill="currentColor" fill-rule="evenodd">
                      <triangleExclamation />
                    </g>
                  </svg>
                </div>
                <p>
                  {{ state.phoneError }}
                </p>
              </div>
            </div>

          </div>

          <!-- <CtaPanel linkForwardUrl="/registrering-roller" linkForwardLabel="Nästa steg" linkBackUrl="/registrering" linkBackLabel="Tillbaka" /> -->
          <CtaPanel>
            <div class="buttons-container spread-buttons">
              <PreviousNavLink go-to-link="/"
                               previous-label="Avbryt"></PreviousNavLink>
              <button class="btn btn-light mb-0 ml-3" type="submit">Nästa steg &nbsp;<span
                class="fas fa-chevron-right"></span></button>
            </div>
          </CtaPanel>

        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "@vue/runtime-core";
import CtaPanel from "../components/CtaPanel.vue";
import { useUserStore } from "@/stores/user";
import { useRouter } from "vue-router";
import { useOrganisationStore } from "@/stores/organisation";
import { ContactInfoModel } from "@Shared/Models/ContactInfoModel";
import { OrganisationModel } from "@Shared/Models/OrganisationModel";
import { validatePhoneNumber } from "@/lib/validators";
import triangleExclamation from "@/components/svg/triangle-exclamation.vue";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

export default defineComponent({

  name: "RegistrationFormStep2",
  components: {
    CtaPanel,
    triangleExclamation,
    PreviousNavLink
  },
  setup() {
    const state = reactive({
      user: {} as ContactInfoModel,
      organisation: {} as OrganisationModel,
      phoneError: ""
    });
    const userStore = useUserStore();
    let user = state.user = userStore.getUser();
    if (!user.email.length) {
      user = state.user = JSON.parse(sessionStorage.getItem("user") as string);
    }

    const organisationStore = useOrganisationStore();
    state.organisation = organisationStore.organisation;
    if (state.organisation.displayName.length < 1) {
      state.organisation = JSON.parse(sessionStorage.getItem("organisation") as string);
    }

    const router = useRouter();

    const form = ref({
      phone: state.user.phone ?? ""
    });

    const onSubmit = async () => {
      if (form.value.phone != state.user.phone && form.value.phone != "") {
        let org = state.organisation;
        state.user.phone = form.value.phone;
        org.contactInfoList = [];
        org.contactInfoList.push(state.user);
        sessionStorage.setItem("organisation", JSON.stringify(org));
      }
      if (!validatePhoneNumber(form.value.phone)) {
        state.phoneError = "Felaktigt telefonnummer";
      } else {
        await router.push("steg-3");
      }
    };

    return {
      state,
      form,
      onSubmit
    };
  }
});
</script>

<style lang="scss" scoped>
.reg-form {
  &__wrapper {
    padding: 1rem;
    border-radius: 0.2rem;
  }

  .org-information-list {
    display: grid;
    grid-template-columns: 6rem auto;

    &:first-child {
      font-weight: bold;
    }

    &__item {
    }
  }

  .cta-container {
    display: flex;
    align-items: baseline;
  }
}

.svg-icon {
  display: inline-block;
  vertical-align: baseline;
  pointer-events: none;
  width: 1rem;
  height: auto;

  &.user_plus-icon {
    width: 1.4rem;
  }

  &.star-icon {
    width: 2rem;
  }
}
</style>